import { WindowMU } from "app/types/WindowMU";

const Backbone = require('backbone')

declare var window: WindowMU

export const Fornecedor = Backbone.Model.extend({

});

window.Fornecedor = Fornecedor

export const Fornecedores = Backbone.Collection.extend({
    model: Fornecedor
})

window.Fornecedores = Fornecedores